module.exports = __webpack_public_path__ + "static/media/email.9641ff6e.png";